import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useOrderAddItemsCatalogNavigation } from '../../lib/useOrderAddItemsCatalogNavigation';

export const AddItemsToOrderButton = () => {
    const { t } = useTranslation();
    const navigateToOrderPropertyCatalog = useOrderAddItemsCatalogNavigation();

    return (
        <Button
            variant="contained"
            onClick={() => navigateToOrderPropertyCatalog()}
            startIcon={<Add />}
            data-testid="btn-add-item"
            sx={{ minWidth: '140px' }}
        >
            {t('Add item')}
        </Button>
    );
};
